// ── Exceptions table — presentational list of exceptions ──
// Sortable headers like every other table. `bare`: no card of its own, for
// when the caller already puts it inside a titled card (the Covenants tab).
import { fmtDate } from "../../../shared/format";
import { Card, STh, Td } from "../../../shared/ui";
import { useSortable } from "../../../shared/hooks";

export const ExceptionsTable = ({ rows, onRowClick, bare }) => {
      const { sorted, sortKey, sortDir, toggle } = useSortable(rows || [], "duedate", "desc");
      if (!rows || rows.length === 0)
        return <div style={{ fontSize:13, color:"var(--color-text-secondary)", padding:"4px 0" }}>No exceptions.</div>;
      const H = ({ label, k }) => <STh label={label} sortKey={k} currentKey={sortKey} currentDir={sortDir} onSort={toggle} />;
      const Box = bare ? "div" : Card;
      return <Box style={{ overflowX:"auto" }}>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead><tr>
            <H label="Company Name" k="companyname" /><H label="Covenant Name" k="covenantname" />
            <H label="Test Date" k="testdate" /><H label="Due Date" k="duedate" />
            <H label="Issue" k="issue" /><H label="PM Response" k="pmresponse" />
          </tr></thead>
          <tbody>
            {sorted.map(r=>(
              <tr key={r.id}
                style={onRowClick ? { cursor:"pointer" } : undefined}
                onClick={onRowClick ? ()=>onRowClick(r) : undefined}
                onMouseEnter={onRowClick ? ev=>ev.currentTarget.style.background="var(--color-background-secondary)" : undefined}
                onMouseLeave={onRowClick ? ev=>ev.currentTarget.style.background="" : undefined}>
                <Td>{r.companyname||"—"}</Td>
                <Td>{r.covenantname||"—"}</Td>
                <Td>{fmtDate(r.testdate)}</Td>
                <Td>{fmtDate(r.duedate)}</Td>
                <Td style={{ whiteSpace:"normal", maxWidth:280 }}>{r.issue||"—"}</Td>
                <Td style={{ whiteSpace:"normal", maxWidth:280 }}>{r.pmresponse||"—"}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>;
    };
